import type {
  CurrentValuationSnapshot,
  PerformanceResult,
} from "@/schemas";

export function mergeCurrentValuationIntoPerformance(
  performanceResult: PerformanceResult | null,
  snapshot: CurrentValuationSnapshot | null,
): PerformanceResult | null {
  if (!performanceResult || !snapshot) {
    return performanceResult;
  }

  const assetsPerformance = Object.fromEntries(
    Object.entries(performanceResult.data.assets_performance).map(
      ([assetId, assetPerf]) => {
        const valuation = snapshot.assets[assetId];
        if (!valuation) {
          return [assetId, assetPerf];
        }

        return [
          assetId,
          {
            ...assetPerf,
            current_value: valuation.value_base,
            current_value_native: valuation.price_native * valuation.quantity,
            shares_owned: valuation.quantity,
            is_closed: Math.abs(valuation.quantity) <= 1e-9,
          },
        ];
      },
    ),
  );

  return {
    ...performanceResult,
    data: {
      ...performanceResult.data,
      assets_performance: assetsPerformance,
      total_performance: {
        ...performanceResult.data.total_performance,
        total_current_value: snapshot.total_current_value,
      },
    },
  };
}
